<template>
  <div>
    <form class="auth-form" @submit.prevent="register()">
      <base-logo-wave class="text-center auth-logo" />

      <h2 class="text-uppercase">{{ $t('auth.sign_up.title') }}</h2>

      <base-checkbox
        v-model="signUpData.agreed_to_terms_and_conditions"
      >
        {{ $t('auth.sign_up.i_agree_with') }}
        &nbsp;<a :href="env.terms_and_conditions_url" target="_blank">{{ $t('auth.sign_up.terms_and_conditions') }}</a>
        {{ $t('auth.sign_up.and') }}
        &nbsp;<a :href="env.privacy_policy_url" target="_blank">{{ $t('auth.sign_up.privacy_policy') }}</a>
      </base-checkbox>

      <base-checkbox class="mb-3" v-model="signUpData.signed_to_newsletter">
        {{ $t('auth.sign_up.news_and_updates_checkbox') }}
      </base-checkbox>

      <google-login-button
        intent="signup"
        :disabled="!signUpData.agreed_to_terms_and_conditions"
        :signed_to_newsletter="signUpData.signed_to_newsletter"
        :agreed_to_terms_and_conditions="signUpData.agreed_to_terms_and_conditions" />

      <div class="d-flex justify-content-center align-items-center mt-2 mb-2">
        <p class="my-1">{{ $t('auth.login.login_option_divider') }}</p>
      </div>

      <base-button
        v-if="!mail_signup"
        type="button"
        class="btn-block btn-sm"
        @click.native="mail_signup = !mail_signup">
        {{ $t('auth.login.signup_with_mail_btn') }}
      </base-button>

      <base-input
        v-if="mail_signup"
        v-model="signUpData.email"
        type="email"
        class="mt-2"
        :placeholder="$t('auth.sign_up.email_placeholder')"
        required
        autofocus
      />

      <base-input
        v-if="mail_signup"
        v-model="signUpData.password"
        type="password"
        :placeholder="$t('auth.sign_up.password_placeholder')"
        required
      />

      <base-input
        v-if="mail_signup"
        v-model="signUpData.password_confirmation"
        type="password"
        :placeholder="$t('auth.sign_up.repeat_password_placeholder')"
        required
      />

       <input
        v-model="signUpData.website"
        type="text"
        tabindex="-1"
        autocomplete="off"
        placeholder="Website"
        style="display:none"
      />

      <base-button
        v-if="mail_signup"
        :disabled="signUpNotValid"
        type="submit"
        class="btn-block btn-lg"
      >
        {{ $t('auth.sign_up.sign_up_btn') }}
      </base-button>

      <div class="text-center mt-4">
        <div id="turnstile-container"></div>
        <small v-if="turnstileError" class="text-danger">{{ $t('common.turnstile_error') }}</small>
      </div>

      <p class="bottom-text text-center">
        {{ $t('auth.sign_up.already_have_an_account') }}
        &nbsp;<router-link :to="{ name: 'login' }">{{ $t('auth.sign_up.log_in') }}</router-link>
      </p>
    </form>
  </div>
</template>

<script>
import BaseLogoWave from '../../components/BaseLogoWave.vue'
import BaseInput from '../../components/BaseInput.vue'
import BaseCheckbox from '../../components/BaseCheckbox.vue'
import BaseButton from '../../components/BaseButton.vue'
import TurnstileMixin from '../../mixins/turnstile'
import GoogleLoginButton from '../../components/GoogleLoginButton.vue'

export default {
  mixins: [TurnstileMixin],
  data () {
    return {
      signUpData: {
        website: '',
        email: '',
        password: '',
        password_confirmation: '',
        signed_to_newsletter: false,
        agreed_to_terms_and_conditions: false,
        turnstile_token: ''
      },
      mail_signup: false,
      env: {
        terms_and_conditions_url: process.env.VUE_APP_TERMS_AND_CONDITIONS_URL,
        privacy_policy_url: process.env.VUE_APP_PRIVACY_POLICY_URL,
        turnstile_site_key: process.env.VUE_APP_TURNSTILE_SITE_KEY
      }
    }
  },
  components: {
    GoogleLoginButton,
    BaseLogoWave,
    BaseInput,
    BaseCheckbox,
    BaseButton
  },
  computed: {
    signUpNotValid () {
      return !this.signUpData.agreed_to_terms_and_conditions || this.signUpData.email.includes('+') || !this.signUpData.turnstile_token
    }
  },
  mounted () {
    this.renderTurnstile('#turnstile-container', this.env.turnstile_site_key, (token) => {
      this.signUpData.turnstile_token = token
    })
  },
  methods: {
    async register () {
      await this.$recaptchaLoaded()
      this.$Progress.start()

      this.$recaptcha('sign_up').then(token => {
        this.$auth.register({
          data: this.signUpData,
          autoLogin: false,
          rememberMe: false
        }).then(() => {
          this.$Progress.finish()
          this.$router.push({ name: 'thank-you-for-subscribing', params: { email: this.signUpData.email } })
        }, (error) => {
          this.$Progress.finish()

          this.$notify({
            type: 'error',
            text: this.devise().formatResponse(error.response.data) || this.$t('common.unknown_error')
          })

          this.signUpData.turnstile_token = ''
          this.resetTurnstile()
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
h2 {
  font-size: 14px;
  color: var(--cool-grey);
  margin-bottom: 20px;
}
</style>
